<template>
<div class="notfound">
    <h1 class="text-center">404</h1>
    <p class="text-center">Oops we couldn't find that page</p>
    </div>
</template>

<style lang="scss" scoped>
.notfound{
    width: 400px;
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
}
</style>
